export default {
    titleText: {
        fontSize: '50px',
        margin: '15vh 0 5vh 0',
        '@media (max-width: 767px)': {
            margin: '12vh 10px 10vh 10px',
            fontSize: '2.3rem',
        }
    }
}